/*
 * AI Website Designer actions are checked against the person viewing the page (getCanUseAiSiteDesigner), not the
 * event owner. These are shown on the controls that viewers without AI access can't use.
 * Copy from SWP-122583.
 */

/** Shown on an AI event's Website card when the viewer can't open AI Website Designer. */
export const AI_SITE_DESIGNER_EDIT_WEBSITE_MESSAGE = 'You need AI access to edit this website.';

/** Shown on every Duplicate entry point of an AI event when the viewer can't use AI Website Designer. */
export const AI_SITE_DESIGNER_DUPLICATE_MESSAGE = 'You need AI access to duplicate this event.';

/** Shown on an AI theme's Edit Theme and Create Event from Theme options when the viewer can't use it. */
export const AI_SITE_DESIGNER_THEME_MESSAGE = 'You need AI access to use this theme.';
